// framework/client/components/DevTools.js

import { ComponentBase } from "../core/ComponentBase.js";

export class DevTools extends ComponentBase {
    static styles = `
        .dev-tools-modal .modal-dialog {
            
        }
        .dev-tools-modal .modal-content {
            height: 100%;
        }

        .dev-tools-container {
            display: flex;
            height: 100%;
        }
        .dev-tools-menu {
            width: 200px;
            background-color: var(--bs-tertiary-bg);
            border-right: 1px solid var(--bs-border-color);
            padding: 1rem;
        }
        .dev-tools-menu ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .dev-tools-menu li {
            margin-bottom: 0.5rem;
        }
        .dev-tools-menu a {
            display: block;
            padding: 0.5rem;
            color: var(--bs-body-color);
            text-decoration: none;
            border-radius: var(--bs-border-radius);
        }
        .dev-tools-menu a:hover,
        .dev-tools-menu a.active {
            background-color: var(--bs-primary);
            color: var(--bs-primary-text-emphasis);
        }

        .dev-tools-content {
            flex-grow: 1;
            padding: 1rem;
            overflow-y: auto; /* Add scrollbar if content overflows */
            max-height: 400px;
        }
         /* Style for modal close button */
        .dev-tools-modal .btn-close {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
            z-index: var(--ab-z-modal);
            background-color: transparent;
            border: none;
            font-size: var(--ab-text-lg);
            opacity: 0.5;
        }
        .dev-tools-modal .btn-close:hover {
            opacity: 1;
        }
        .dev-tools-content h2{
            margin-top:0;
        }
    `;

    constructor(config) {
        super(config);
        this.modal = null;
        this.modalInstance = null;
        this.activeContent = null;
        this.applyStyles();
    }

    async initialize() {
        const clientConfig = await this.appClient.sessionTokenHandler.getClientConfig();
        if (clientConfig.runtimeMode !== 'development') {
            return;
        }

        this.registerKeyboardShortcut();
        await this.render(); // Create elements, even if not shown yet
    }


    async render() {
        // Create modal (only once)
        if (!this.container) {
            this.container = document.createElement('div');
        }

        if (!this.modal) {
            this.modal = document.createElement('div');
            this.modal.classList.add('modal', 'fade', 'dev-tools-modal');
            this.modal.innerHTML = `
            <div class="modal-dialog dev">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Developer Tools</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="dev-tools-container">
                            <div class="dev-tools-menu">
                                <ul>
                                    <li><a href="#" data-content="translations">Translations</a></li>
                                    <!-- Add more menu items here -->
                                </ul>
                            </div>
                            <div class="dev-tools-content">
                                <!-- Content will be loaded here -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `;
            document.body.appendChild(this.modal); // Append to body
            // Event delegation for menu clicks
            this.modal.querySelector('.dev-tools-menu ul').addEventListener('click', (event) => {
                event.preventDefault();
                if (event.target.tagName === 'A') {
                    const contentId = event.target.dataset.content;
                    this.showContent(contentId);
                    // Remove 'active' class from all menu items
                    this.modal.querySelectorAll('.dev-tools-menu a').forEach(a => a.classList.remove('active'));
                    // Add 'active' class to the clicked menu item
                    event.target.classList.add('active');
                }
            });

            //close event.
            this.modal.addEventListener('hidden.bs.modal', () => {
                this.onClose();
            });

        }

        return this.container; // Return the modal element
    }


    showContent(contentId) {
        if (this.activeContent === contentId) return; //do nothing if same content id.

        const contentContainer = this.modal.querySelector('.dev-tools-content');
        contentContainer.innerHTML = ''; // Clear previous content
        this.activeContent = contentId; //update active content.

        switch (contentId) {
            case 'translations':
                this.showTranslationsContent(contentContainer);
                break;
            // Add more cases for other content sections
            default:
                contentContainer.innerHTML = '<h2>Content Not Found</h2>';
        }
    }
    async showTranslationsContent(container) {
        const title = document.createElement('h2');
        title.textContent = "Translations";
        container.appendChild(title);

        const applyButton = document.createElement('button');
        applyButton.textContent = 'Apply Translations';
        applyButton.classList.add('btn', 'btn-primary');
        applyButton.addEventListener('click', async () => {
            await this.appClient.tx.applyTranslations();
            this.updateUntranslatedKeys(keysContainer);

        });
        container.appendChild(applyButton);


        const saveButton = document.createElement('button');
        saveButton.textContent = 'Save Translations';
        saveButton.classList.add('btn', 'btn-primary');
        saveButton.addEventListener('click', async () => {
            await this.appClient.tx.saveTranslations();
        });
        container.appendChild(saveButton);

        // Add forceTranslate checkbox.
        const forceTranslateCheckbox = document.createElement('input');
        forceTranslateCheckbox.type = 'checkbox';
        forceTranslateCheckbox.id = 'forceTranslate';
        forceTranslateCheckbox.checked = this.appClient.tx.forceTranslate; // Set initial state
        forceTranslateCheckbox.addEventListener('change', async (event) => {
            this.appClient.tx.forceTranslate = event.target.checked;
            //re apply translations.
            await this.appClient.tx.loadTranslations(this.appClient.tx.currentLanguage);

        });


        const forceTranslateLabel = document.createElement('label');
        forceTranslateLabel.textContent = ' Force Translate';
        forceTranslateLabel.htmlFor = 'forceTranslate';
        forceTranslateLabel.classList.add('ms-2');

        const checkboxContainer = document.createElement('div');
        checkboxContainer.appendChild(forceTranslateCheckbox);
        checkboxContainer.appendChild(forceTranslateLabel);
        container.appendChild(checkboxContainer);


        //add display of untranslated keys.
        const keysContainer = document.createElement('div');
        keysContainer.classList.add('mt-3');
        container.appendChild(keysContainer);

        this.keysContainer = keysContainer;
        //get and update the list.
        this.updateUntranslatedKeys(keysContainer);

    }

    updateUntranslatedKeys(container) {

        const untranslatedKeys = this.appClient.tx.untranslatedKeys;

        container.innerHTML = ''; //clear

        const title = document.createElement('h3');
        title.textContent = `Untranslated Keys (${untranslatedKeys.size})`;
        container.appendChild(title);

        if (untranslatedKeys.size === 0) {
            container.innerHTML += '<p>No untranslated keys found.</p>';
            return;
        }

        const list = document.createElement('ul');
        untranslatedKeys.forEach(key => {
            const listItem = document.createElement('li');
            listItem.textContent = key;
            list.appendChild(listItem);
        });
        container.appendChild(list);

    }

    registerKeyboardShortcut() {
        document.addEventListener('keyup', (event) => {
            if (event.altKey && event.ctrlKey && (event.key === 'I' || event.key === 'i')) {
                event.preventDefault(); // Prevent default browser behavior
                this.toggleModal();
            }
        });
    }

    toggleModal() {
        if (!this.modalInstance) {
            this.modalInstance = new bootstrap.Modal(this.modal);
        }
        this.modalInstance.toggle();
    }
    onClose() {
        this.activeContent = null; //reset.
        this.modal.querySelectorAll('.dev-tools-menu a').forEach(a => a.classList.remove('active')); //reset active
    }

    destroy() {
        if (this.modalInstance) {
            this.modalInstance.dispose();
            this.modalInstance = null;
        }

        if (this.modal) {
            this.modal.remove(); //remove from dom.
            this.modal = null;
        }
        // Remove the keydown event listener to avoid memory leaks
        document.removeEventListener('keydown', this.boundKeydownHandler);
    }
}